import React from 'react';
import { cn } from '../../../utils/classnames';

const CustomInput = ({
  disabled = false,
  label,
  name,
  type = 'text',
  placeholder,
  required = false,
  value,
  onChange,
  labelClassName = '',
  inputClassName = '',
  py = 'py-3',
}) => {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className={cn('text-blueDarker font-normal', labelClassName)}>
          {label}
          {/* {required && <span className="ml-1.5">*</span>} */}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={cn('w-full border border-bluePale rounded-xl px-3 placeholder-blueSteel', inputClassName, py)}
      />
    </div>
  );
};

export default CustomInput;
